import { render } from "./techniquesChecbox.vue?vue&type=template&id=fdd5b748&scoped=true"
import script from "./techniquesChecbox.vue?vue&type=script&lang=js"
export * from "./techniquesChecbox.vue?vue&type=script&lang=js"

import "./techniquesChecbox.vue?vue&type=style&index=0&id=fdd5b748&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdd5b748"]])

export default __exports__